module.exports = __webpack_public_path__ + "static/media/SangeandYasha.b6f69cf7.png";